<template>
  <v-app>
    <v-main class="main">

      <!-- Sidebar -->

      <!-- <Sidebar :collapsed="isSidebarCollapsed" /> -->
      <AdminSidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
        @update:drawerOpen="drawerOpen = $event" />


      <!-- Main content -->
      <v-container fluid class="main-content pa-4">

        <!-- Header -->
        <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar"
          @toggle-darkmode="toggleDarkMode" />

        <!-- Stat Cards -->
        <v-row class="stats mt-4" dense>
          <v-col cols="12" sm="6" md="3">
            <StatCard title="Total Wallet Balance" :value="formatCurrencyCompact(walletBalance)"
              subtext="Across all investment" icon="mdi-wallet-bifold-outline" iconColor="#64cf69" />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <StatCard title="Active Investments Count" :value="activeInvestmentCount" subtext="Across all investment"
              icon="mdi-wallet-travel" iconColor="#64cf69" />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <StatCard title="Total Completed Investments" :value="totalCompletedInvestment" subtext="Found in portfolio"
              icon="mdi-wallet-giftcard" iconColor="#64cf69" />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <StatCard title="Total Users" :value="totalUsers" subtext="As of today" icon="mdi-account-group-outline"
              iconColor="#64cf69" />
          </v-col>
        </v-row>

        <!-- Stat Cards row 2-->
        <v-row class="stats mt-4" dense>
          <v-col cols="12" sm="6" md="3">
            <StatCard title="Total Investments" :value="formatCurrencyCompact(totalInvestment)"
              subtext="Across all investment" icon="mdi-briefcase-arrow-left-right-outline" iconColor="#64cf69" />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <StatCard title="Total Deposit" :value="formatCurrency(totalDeposit)" subtext="Across all investment"
              icon="mdi-bank-transfer-in" iconColor="#64cf69" />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <StatCard title="Total Withdrawal" :value="formatCurrencyCompact(totalWithdrawal)"
              subtext="Across all investment" icon="mdi-bank-transfer-out" iconColor="#64cf69" />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <StatCard title="Total Successful Transactions" :value="formatCurrencyCompact(totalSuccessfulTransactions)"
              subtext="As of today" icon="mdi-swap-horizontal" iconColor="#64cf69" />
          </v-col>
        </v-row>

        <!-- Large content box (chart) -->
        <v-card class="large-box mt-6 pa-4">
          <!-- Placeholder: Table or Chart -->
          <v-row>
            <!-- <v-col cols="12" sm="3">
              <Skeleton v-if="loading" height="250px" />
              <Chart v-if="!loading && stat" type="doughnut" :data="chartData" :options="chartOptions" :key="doughnutKey" class="w-full" />
            </v-col> -->

            <v-col cols="12" sm="12">
              <div class="chart-container">
                <Chart type="bar" :data="barChartData" :options="barChartOptions" style="height:400px" />
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-container>

    </v-main>
  </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, watch } from "vue"
import AdminSidebar from "@/components/AdminSidebar.vue"
import Header from "@/components/Header.vue"
import StatCard from "@/components/StatCard.vue"
import Chart from 'primevue/chart'
//import { useAuthStore } from "@/store/auth"
import { userStore } from "@/store/user"
import { formatCurrencyCompact, formatCurrency } from "@/util"


const isSidebarCollapsed = ref(false)
const isDarkMode = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)

//const auth = useAuthStore()
const usr = userStore()

/**============= handle Header emits ============*/
const toggleSidebar = () => {
  if (isMobile.value) {
    // On mobile: open/close drawer
    drawerOpen.value = !drawerOpen.value
  } else {
    // On desktop: collapse/expand sidebar
    isSidebarCollapsed.value = !isSidebarCollapsed.value
  }
}

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768
  if (!isMobile.value) drawerOpen.value = true // desktop always open
  else drawerOpen.value = false                 // mobile closed by default
}

const toggleDarkMode = () => {
  isDarkMode.value = !isDarkMode.value
  //console.log('Layout: new isDarkMode:', isDarkMode.value)
}
const stat = computed(() => usr.stat)

const totalInvestment = computed(() => stat.value?.kpis?.total_investment || 0)
const totalUsers = computed(() => stat.value?.kpis?.total_users || 0)
const walletBalance = computed(() => stat.value?.kpis?.total_wallet_balance || 0)
const totalCompletedInvestment = computed(() => stat.value?.kpis?.total_completed_investment || 0)
const activeInvestmentCount = computed(() => stat.value?.kpis?.total_active_investment_count || 0)
const totalDeposit = computed(() => stat.value?.kpis?.total_deposit || 0)
const totalWithdrawal = computed(() => stat.value?.kpis?.total_withdrawal || 0)
const totalSuccessfulTransactions = computed(() => stat.value?.kpis?.total_successful_transaction || 0)
// const monthlyInvestments = computed(() => stat.value?.kpi?.monthly_investments || [])
// const monthlyWithdrawals = computed(() => stat.value?.kpi?.monthly_withdrawals || [])

const doughnutKey = ref(0)

const loading = ref(true)

onMounted(async () => {
  checkMobile()
  window.addEventListener("resize", checkMobile)
  try {
    await usr.loadDashboardData()
  } catch (error) {
    console.error(error)
  }
  loading.value = false
});

// Reactive computed properties
//const partnerName = computed(() => auth.partner?.partner?.name || '')
// const partnerEmail = computed(() => auth.partner?.email || '')
// const partnerPhone = computed(() => auth.partner?.phone || '')
// const partnerWebsite = computed(() => auth.partner?.website || '')
// const partnerAddress = computed(() => auth.partner?.address || '')

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile)
})

/**============= doughnut Chart option ============*/
// const chartData = ref({
//   labels: ['Total Investments', 'Withdrawals'],
//   datasets: [
//     {
//       data: [
//         stat.value?.totalInvestments || 0,
//         stat.value?.totalWithdrawal || 0
//       ],
//       backgroundColor: [
//         '#66BB6A',
//         '#EF5350'
//       ],
//       hoverBackgroundColor: [
//         '#81C784',
//         '#E57373'
//       ]
//     }
//   ]
// })

// const chartOptions = ref({
//   plugins: {
//     legend: {
//       position: 'bottom'
//     }
//   }
// })

/**============= Bar chart option ===============*/

const months = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
]

const formatMonthlyData = (apiData) => {
  const result = new Array(12).fill(0)

  apiData?.forEach(item => {
    const date = new Date(item.month)
    const monthIndex = date.getMonth() // 0 = Jan

    result[monthIndex] = Number(item.total)
  })

  return result
}

const barChartData = computed(() => {
  return {
    labels: months,
    datasets: [
      {
        label: 'Investments',
        data: formatMonthlyData(stat.value?.kpis?.monthly_investments),
        backgroundColor: '#64cf69'
      },
      {
        label: 'Withdrawals',
        data: formatMonthlyData(stat.value?.kpis?.monthly_withdrawals),
        backgroundColor: '#EF5350'
      }
    ]
  }
})

const barChartOptions = ref({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top'
    }
  }
})


watch(stat, () => {
  doughnutKey.value++
})
</script>

<style scoped>
.main {
  display: flex;
  min-height: 100vh;
  /* font-family: sans-serif; */
}

.sidebar {
  background-color: #f3f4f6;
  padding: 20px;
}

.main-content {
  flex: 1;
  background-color: #f8fafc;
  /* rounded top corners */
  /* border-top-left-radius: 24px;
  border-top-right-radius: 24px; */

  /* background color */
  /* background-color: #ffffff; */

  /* ensure content below sidebar is clipped */
  /* overflow: hidden; */
}

.large-box {
  min-height: 300px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  background-color: #fff;
}

/* Override v-card inside StatCard if needed */
.stats .v-card {
  text-align: center;
}

:deep(.modern-table .p-datatable-thead > tr > th) {
  background: #eef7f0;
  color: #065f46;
  font-weight: 600;
  border-bottom: 2px solid #c1edc3;
}

:deep(.modern-table .inner .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #065f46;
  font-weight: 600;
  border-bottom: 2px solid #c1edc3;
}
</style>
